import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import Select from "react-select";
import jQuery from "jquery";
import { CSVLink } from "react-csv";
import { getApiBaseUrl } from "../../utils/utils";
export default function GetMedicalOrders() {
  pdfMake.vfs = pdfFonts.vfs;
  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState("");
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const $ = jQuery.noConflict();

  const [selectedPaymentType, setSelectedPaymentType] = useState("All");
  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");
    });
  }, []);

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };
  const buttonsyle1 = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginLeft: "75%",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
    marginBottom: "2%",
  };

  const [msg, setMsg] = useState("");
  const [errormsg, setError] = useState("");

  useEffect(() => {
    // Fetch drivers from the API on component mount
    fetchDrivers();
    getUserList();
  }, []);

  const [scaninfo, setScaninfo] = useState({
    driver: "",
  });
  const [drivers, setDrivers] = useState();
  const [awb, setAwb] = useState();
  const fetchDrivers = async () => {
    try {
      // Replace this API endpoint with the actual one that fetches drivers based on the emirate
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getAllDrivers`
      );

      if (response.data.success) {
        const driversData = response.data.data; // The array of driver objects

        // Map the response to extract driverId and name
        const driversList = driversData.map((driver) => ({
          driver_id: driver.driverId,
          driver_name: driver.name,
        }));

        // Set the drivers state
        setDrivers(driversList);
      } else {
        console.error("Error fetching drivers for emirate:");
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  };

  const [users, setusers] = useState();
  const getUserList = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

    // Send a GET request to the new API
    try {
      const res = await axios.get(API_PATH);

      console.log(res.data); // Log the response to inspect it

      // Check if the response contains 'data' and if it's an array
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setusers(res.data.data); // Update the personnel list in the state
      } else {
        console.log(
          "No personnel data found in the response or response is not successful"
        );
      }
    } catch (err) {
      console.log("Error fetching personnel list:", err);
    }
  };

  // console.log('drivers:', drivers)
  // console.log('scan:', scaninfo)
  // console.log('users:', users)

  const getDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}shypvdriverapp/jobs/getMedicalReportWithPartnerIdWithDateRange`,
        {
          params: {
            partnerId: selectedPartner,
            fromDate: datechosenfrom, // e.g. '2025-07-31'
            toDate: datechosento, // e.g. '2025-07-31'
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response Data:", response.data);

      if (response.data.success) {
        // Filter only medical type items, if needed:
        const filtered = (response.data.data || []).filter(
          (item) => item.shipmentType?.toLowerCase() === "medical"
        );

        setShipmentDetails(filtered);
        fetchDriverInfo(driver);
        setLoading(false);
        if (!filtered.length) {
          setError("Booking details not found");
        } else {
          setError("");
        }
      } else {
        setShipmentDetails([]);
        setError(response.data.message || "Booking details not found");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
      setError("An error occurred while fetching details");
      setLoading(false);
    }
  };

  const [driverdata, setdriverdata] = useState({
    driverid: "",
    team: "",
    zone: "",
  });

  const fetchDriverInfo = async (driverId) => {
    try {
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getDriver`,
        {
          params: { driverId },
        }
      );

      console.log("Driver Info:", response.data);
      if (response.data.success) {
        const driverInfo = response.data.data;

        setdriverdata({
          driverid: driverInfo.driverId || "",
          team: driverInfo.team?.teamName || "",
          zone: driverInfo.zone?.emirates || "",
        });
      } else {
        setdriverdata({ driverid: driverId, team: "", zone: "" });
      }
      // Optionally update state or show UI
      // setDriverDetails(response.data);
    } catch (error) {
      console.error("Error fetching driver info:", error);
      setdriverdata({ driverid: driverId, team: "", zone: "" });
    }
  };

  const [errorNew, seterrorNew] = useState("");

  const [allStatus, setallStatus] = useState();
  useEffect(() => {
    // Make the API call when the component mounts
    axios
      .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
      .then((response) => {
        setallStatus(response.data.data); // Store the data in state
        setLoading(false); // Set loading to false when done
      })
      .catch((err) => {
        setError(err); // Store the error in state if something goes wrong
        setLoading(false); // Set loading to false even if there's an error
      });
  }, []);

  console.log("all", allStatus);

  //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
  const [newStatus, setnewStatus] = useState(0);
  // Handle status change
  const handleStatusChange = (index, newStatus) => {
    setnewStatus(newStatus);
    // Create a copy of the current shipment details
    const updatedShipmentDetails = [...shipmentDetails];

    // Update the status at the specified index
    updatedShipmentDetails[index].status = newStatus;

    // Update the state with the new shipment details array
    setShipmentDetails(updatedShipmentDetails);
  };

  const handleAwbChange = (e) => {
    // Update the input field value
    setAwb(e.target.value);
  };

  function resetData() {
    setShipmentDetails([]);
    setAwb("");
  }
  console.log("shipmentDetails", shipmentDetails);

  const [datechosenfrom, setdatechosenfrom] = useState();
  const [datechosento, setdatechosento] = useState();
  const [driver, setdriverchosen] = useState();

  const handleFilterChange = (e) => {
    setSelectedPaymentType(e.target.value);
  };

  const filteredShipmentDetails = shipmentDetails.filter((data) => {
    if (selectedPaymentType === "COD") {
      return data.paymentType === selectedPaymentType; // Filter by COD or NON COD
    } else if (selectedPaymentType === "NON COD") {
      return data.paymentType !== "COD"; // Filter by COD or NON COD
    } else if (selectedPaymentType === "DELIVERED") {
      return data.STATUS === "DELIVERED"; // Filter by COD or NON COD
    } else if (selectedPaymentType === "PENDING") {
      return data.STATUS !== "DELIVERED"; // Filter by COD or NON COD
    } else {
      return true; // Show all
    }
  });

  const totalCod =
    filteredShipmentDetails &&
    filteredShipmentDetails
      .filter((data) => data.STATUS?.toLowerCase() === "delivered")
      .reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

  const [actualCollectedMap, setActualCollectedMap] = useState({});

  // Update actualCollectedMap when the component mounts
  useEffect(() => {
    const initialMap = {};
    filteredShipmentDetails.forEach((item) => {
      initialMap[item.bookingId] = item.cashCollected ?? 0;
    });
    setActualCollectedMap(initialMap);
  }, [filteredShipmentDetails]);

  // Calculate the sum of all values in actualCollectedMap
  const getTotalActualCollected = () => {
    return filteredShipmentDetails
      .filter((data) => data.STATUS?.toLowerCase() === "delivered")
      .reduce((sum, data) => {
        const collectedAmount = actualCollectedMap[data.bookingId];
        return sum + (collectedAmount ? parseFloat(collectedAmount) : 0); // Safely sum the values
      }, 0);
  };

  const generateCSVData = (type) => {
    // Filter data based on the passed type
    let filteredData = shipmentDetails.filter(
      (data) => data.STATUS === "DELIVERED" || data.STATUS === "PICKED_UP"
    );

    if (type === "DELIVERED") {
      console.log("dele");
      filteredData = shipmentDetails.filter(
        (data) => data.STATUS === "DELIVERED"
      );
    } else if (type === "PENDING") {
      // filteredData = shipmentDetails.filter((data) => data.paymentType !== "COD");
      filteredData = shipmentDetails.filter(
        (data) => data.STATUS !== "DELIVERED"
      );
      //   filteredData = shipmentDetails.filter((data) => data.STATUS && data.STATUS.trim().toUpperCase() !== "DELIVERED");
    } else if (type === "nonCOD") {
      filteredData = shipmentDetails.filter(
        (data) => data.paymentType !== "COD"
      );
    } else if (type === "COD") {
      filteredData = shipmentDetails.filter(
        (data) => data.paymentType === "COD"
      );
    } else {
      filteredData = shipmentDetails;
    }

    const csvData = filteredData.map((data) => {
      const [datePart = "", timePart = ""] = (data.modifiedDate || "").split(
        " "
      );
      const isDelivered = data.STATUS?.toLowerCase() === "delivered";

      return {
        AWB: data.jobId,
        Status: data.STATUS,
        "Last Transit Date": datePart,
        "Last Transit Time": timePart,
        Courier: data.driverName || "--",
        Shipper: data.shipperContactName || "--",
        Consignee: data.contactName
          ? data.contactAddress
            ? `${data.contactName} - ${data.contactAddress}`
            : data.contactName
          : "",
        "Pickup Location": data.pickupLocation || "--",
        "Ambient Count": data.ambientCount ?? "0",
        "Ambient Temp": data.ambientTemperature || "--",
        "Chilled Count": data.chilledCount ?? "0",
        "Chilled Temp": data.chilledTemperature || "--",
        "Frozen Count": data.frozenCount ?? "0",
        "Frozen Temp": data.frozenTemperature || "--",
        "Handover by": data.handover || "--",
        "Received by": data.receiverName || "--",
        "Updated By": data.updated_by ? data.updated_by : data.driverName,
      };
    });

    const totalCodcsv =
      filteredData &&
      filteredData
        .filter((data) => data.STATUS?.toLowerCase() === "delivered")
        .reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

    // Add the Total COD as a row at the end of the CSV
    const csvDataWithTotal = [
      ...csvData,
      ...(type && type !== "nonCOD"
        ? [
            {
              AWB: "",
              Status: "",
              "Last Transit Date": "",
              "Last Transit Time": "",
              Courier: "",
              Shipper: "",
              Consignee: "",
              "Pickup Location": "",
              "Ambient Count": "",
              "Ambient Temp": "",
              "Chilled Count": "",
              "Chilled Temp": "",
              "Frozen Count": "",
              "Frozen Temp": "",
              "Handover by": "",
              "Received by": "",
              "Updated By": "",
              // Add custom total columns at the end if needed
              "Ambient Temp": "",
              "Chilled Temp": "",
              "Frozen Temp": "",
              // Optionally add a column like:
              // "Total COD Amount": totalCodcsv,
            },
          ]
        : []),
    ];

    return csvDataWithTotal;
  };

  // Add the Total COD as a row at the end of the CSV

  // CSV headers
  const csvHeaders = [
    { label: "AWB", key: "AWB" },
    { label: "Status", key: "Status" },
    { label: "Last Transit Date", key: "Last Transit Date" },
    { label: "Last Transit Time", key: "Last Transit Time" },
    { label: "Courier", key: "Courier" },
    { label: "Shipper", key: "Shipper" },
    { label: "Consignee", key: "Consignee" },
    { label: "Pickup Location", key: "Pickup Location" },
    { label: "Ambient Count", key: "Ambient Count" },
    { label: "Ambient Temp", key: "Ambient Temp" },
    { label: "Chilled Count", key: "Chilled Count" },
    { label: "Chilled Temp", key: "Chilled Temp" },
    { label: "Frozen Count", key: "Frozen Count" },
    { label: "Frozen Temp", key: "Frozen Temp" },
    { label: "Handover by", key: "Handover by" },
    { label: "Received by", key: "Received by" },
    { label: "Updated By", key: "Updated By" },
  ];

  const csvDataForDownload = generateCSVData("DELIVERED"); // Replace with 'pending' for pending records
  const csvDataForDownloadAll = generateCSVData("ALL"); // Replace with 'pending' for pending records
  const csvDataForDownloadPending = generateCSVData("PENDING"); // Replace with 'pending' for pending records
  const csvDataForNonCod = generateCSVData("nonCOD"); // Replace with 'pending' for pending records
  const csvDataForCOD = generateCSVData("COD"); // Replace with 'pending' for pending records

  const hasDeliveredRecords = shipmentDetails.some(
    (data) => data.STATUS.toUpperCase() === "DELIVERED"
  );

  // Handle filter change

  const [searchQuery, setSearchQuery] = useState("");

  const filteredDrivers = Array.isArray(drivers)
    ? drivers.filter((driver) =>
        driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const driverOptions = filteredDrivers.map((driver) => ({
    value: driver.driver_id,
    label: `${driver.driver_id} - ${driver.driver_name}`,
  }));

  const handleChange = (selectedOption) => {
    setdriverchosen(selectedOption.value);
  };

  const [partners, setPartners] = useState([]);
  useEffect(() => {
    const fetchPartners = async () => {
      const baseApiUrl = getApiBaseUrl();
      try {
        const response = await axios.get(
          `${baseApiUrl}/v1.0/partner/retrieve_list?page=0`
        );
        setPartners(
          (response.data.data || []).filter(
            (partner) => partner.accountType.toLowerCase() === "medical"
          )
        );
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        // setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  const [selectedPartner, setSelectedPartner] = useState("0");

  const handleSelectChange = (e) => {
    const partnerId = e.target.value;

    if (partnerId === "0") {
      setSelectedPartner("0");

      return;
    }

    const partner = partners.find((p) => String(p.pid) === partnerId);
    setSelectedPartner(partner.pid);
  };

  const [pdfload, setpdfload] = useState(false);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const [datechosen, setdatechosen] = useState();

  const handleGeneratePdf = async (shipmentDetails) => {
    setpdfload(true);
    const filteredAWBs = Array.from(
      new Set(
        shipmentDetails
          .filter((item) => ["PICKED_UP", "DELIVERED"].includes(item.STATUS))
          .map((item) => item.jobId)
          .filter(Boolean)
      )
    );

    const jobStatusTimesMap = {};

    const fleetId = 80;
    const bookingIdsParam = filteredAWBs.join(","); // e.g., "UB72-25A8066_1_test,UB72-25A7875_1_test,..."

    const baseApiUrl = getApiBaseUrl();

    try {
      const response = await axios.get(
        `${baseApiUrl}/shypv/order/task/status/Allhistory`,
        {
          params: {
            bookingIds: bookingIdsParam,
          },
        }
      );

      console.log("all history: ", response.data);
      const data = response.data?.data || [];

      data.forEach((entry) => {
        const awb = entry.bookingId;
        const status = entry.typ;
        const time = entry.dt || null;

        if (!jobStatusTimesMap[awb]) {
          jobStatusTimesMap[awb] = {};
        }

        if (status && time) {
          jobStatusTimesMap[awb][status] = time;
        }
      });

      console.log("jobStatusTimesMap:", jobStatusTimesMap);
      // ✅ Now jobStatusTimesMap is ready and has the same structure as before
    } catch (error) {
      console.error("Failed to fetch bulk status:", error);
    }

    await delay(300);
    generatePdf(shipmentDetails, jobStatusTimesMap);
  };

  const generatePdf = (shipmentDetails, jobStatusTimesMap) => {
    const grouped = {};
    let grandTotalSamples = 0;
    let isFirstGroup = true;

    console.log("before: ", shipmentDetails);
    let filteredData = shipmentDetails.filter(
      (data) => data.STATUS === "DELIVERED" || data.STATUS === "PICKED_UP"
    );

    console.log("filtereddata: ", filteredData);
    //   filteredData.forEach((data, index) => {
    //     const [date] = (data.modifiedDate || "").split(" ");
    //     const key = `${date}`;
    //     if (!grouped[key]) grouped[key] = [];
    //     grouped[key].push({ index: index + 1, ...data });
    //   });

    filteredData.forEach((data, index) => {
      const [date] = (data.modifiedDate || "").split(" ");
      const driver = data.driverName || "--";
      const key = `${date}||${driver}`;

      if (!grouped[key]) grouped[key] = [];
      grouped[key].push({ index: index + 1, ...data });
    });

    const content = [];

    for (const [key, shipments] of Object.entries(grouped)) {
      // const date = key;
      const [date, driver] = key.split("||");
      const courier = shipments[0]?.driverName || "--";
      const area = shipments[0]?.contactAddress || "Unknown Area";

      let ambientTotal = 0,
        chilledTotal = 0,
        frozenTotal = 0;

      const tableBody = [
        [
          { text: "No", rowSpan: 2, style: "tableHeader" },
          { text: "AWB", rowSpan: 2, style: "tableHeader" },
          { text: "Shipper", rowSpan: 2, style: "tableHeader" },
          { text: "Consignee", rowSpan: 2, style: "tableHeader" },
          { text: "Dest", rowSpan: 2, style: "tableHeader" },
          { text: "Last Modified Time", rowSpan: 2, style: "tableHeader" },
          { text: "Pickup Time", rowSpan: 2, style: "tableHeader" },
          { text: "Delivery Time", rowSpan: 2, style: "tableHeader" },
          { text: "Status", rowSpan: 2, style: "tableHeader" },
          { text: "Received by", rowSpan: 2, style: "tableHeader" },
          { text: "PC", rowSpan: 2, style: "tableHeader" },
          {
            text: "Samples",
            colSpan: 3,
            style: "tableHeader",
            alignment: "center",
          },
          {},
          {},
          { text: "Total", rowSpan: 2, style: "tableHeader" }, // ✅ Final total column
        ],
        [
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          {},
          { text: "Ambient", style: "tableSubHeader" },
          { text: "Chilled", style: "tableSubHeader" },
          { text: "Frozen", style: "tableSubHeader" },
          { text: "Total", style: "tableSubHeader" },
        ],
      ];

      shipments.forEach((data, i) => {
        const time = data.modifiedDate || "-- --";
        const ambient = parseInt(data.ambientCount || 0) || 0;
        const chilled = parseInt(data.chilledCount || 0) || 0;
        const frozen = parseInt(data.frozenCount || 0) || 0;
        const totalSamples = ambient + chilled + frozen;

        ambientTotal += ambient;
        chilledTotal += chilled;
        frozenTotal += frozen;

        const sampleCell = (count, temp) => ({
          stack: [
            { text: count.toString(), alignment: "center" },
            {
              text: `temp - ${temp || "--"}`,
              fontSize: 7,
              italics: true,
              alignment: "center",
            },
          ],
        });

        const awb = data.jobId;
        const statusMap = jobStatusTimesMap[awb] || {};
        const pickupTime = statusMap.PICKED_UP || "--";
        const deliveryTime = statusMap.DELIVERED || "--";

        tableBody.push([
          i + 1,
          data.jobId || "--",
          data.shipperContactName || "--",
          `${data.contactName || ""} - ${data.contactAddress || ""}`,
          data.contactAddress || "--",
          time || "--",
          pickupTime,
          deliveryTime,
          data.STATUS || "--",
          data.receiverName || "--",
          data.hand || "--",
          sampleCell(ambient, data.ambientTemperature),
          sampleCell(chilled, data.chilledTemperature),
          sampleCell(frozen, data.frozenTemperature),
          { text: totalSamples.toString(), alignment: "center" },
        ]);
      });

      const totalAllSamples = ambientTotal + chilledTotal + frozenTotal;
      grandTotalSamples += totalAllSamples;

      // ✅ Total row
      tableBody.push([
        { text: "Total", colSpan: 11, alignment: "right", bold: true },
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        { text: ambientTotal.toString(), alignment: "center", bold: true },
        { text: chilledTotal.toString(), alignment: "center", bold: true },
        { text: frozenTotal.toString(), alignment: "center", bold: true },
        { text: totalAllSamples.toString(), alignment: "center", bold: true },
      ]);

      if (isFirstGroup) {
        content.push(
          {
            text: "TIME EXPRESS PARCELS DELIVERY LLC",
            style: "header",
            alignment: "center",
            margin: [0, 0, 0, 5],
          },
          {
            text: `Total Consignments Pickupdate from ${datechosenfrom} to ${datechosento} `,
            style: "subheader",
            alignment: "center",
            margin: [0, 0, 0, 10],
          }
        );
        isFirstGroup = false;
      }

      content.push(
        {
          columns: [
            { text: `Courier: ${courier}`, style: "subheader" },
            {
              text: `Pickup Date: ${date}`,
              style: "subheader",
              alignment: "center",
            },
            { text: `Area: ${area}`, style: "subheader", alignment: "right" },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: `Total Consignments on ${date} by ${courier}`,
          alignment: "center",
          style: "subheader",
          margin: [0, 0, 0, 10],
        },
        {
          table: {
            headerRows: 2,
            widths: [
              20,
              65,
              45,
              50,
              40,
              30,
              50,
              50,
              50,
              40,
              20,
              30,
              30,
              30,
              25,
              25, // ✅ updated widths
            ],
            body: tableBody,
          },
          layout: "lightHorizontalLines",
          fontSize: 8,
          margin: [0, 0, 0, 20],
        }
      );
    }

    content.push({
      text: `Grand Total Samples: ${grandTotalSamples}`,
      alignment: "right",
      bold: true,
      margin: [0, 0, 20, 10],
      fontSize: 10,
    });

    const docDefinition = {
      content,
      pageSize: "A4",
      pageOrientation: "landscape",
      styles: {
        header: { fontSize: 14, bold: true },
        subheader: { fontSize: 10, bold: true },
        tableHeader: { bold: true, fillColor: "#eeeeee", alignment: "center" },
        tableSubHeader: { bold: true, alignment: "center" },
      },
    };

    pdfMake.createPdf(docDefinition).getBlob((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const newWindow = window.open(blobUrl);

      if (!newWindow) {
        alert("Popup blocked! Please allow popups for this site.");
      }
      setpdfload(false);
    });
  };

  return (
    <div>
      <div className="form-container">
        <h4>Get Report</h4>
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="driver">From Date:</label>
                  <input
                    type="date"
                    id="date"
                    value={datechosenfrom}
                    onChange={(e) => setdatechosenfrom(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="driver">To Date:</label>
                  <input
                    type="date"
                    id="date"
                    value={datechosento}
                    onChange={(e) => setdatechosento(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Driver Selection */}
            <div className="row">
              <div className="col-md-8">
                <div className="form-group">
                  <label htmlFor="formGroupExampleInput2" className="m-form">
                    Partner*
                  </label>
                  <select
                    onChange={handleSelectChange}
                    value={selectedPartner}
                    style={{ marginRight: "10px" }}
                  >
                    <option value="" disabled>
                      -- Select a partner --
                    </option>
                    <option value="0">All</option>
                    {partners &&
                      [...partners]
                        .sort((a, b) => a.pname.localeCompare(b.pname))
                        .map((partner) => (
                          <option key={partner.pid} value={partner.pid}>
                            {partner.pname}
                          </option>
                        ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <a
                  onClick={getDetails}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Submit
                </a>
              </div>
            </div>
            <p style={{ color: "red", marginTop: "2%" }}>{errormsg}</p>
          </div>
          <div className="col-md-4">
            {shipmentDetails.length > 0 && (
              <div className="row">
                <div className="col-md-11">
                  {/* Use inline-block for alignment */}
                  <div className="text-right">
                    {/* Delivered Link */}
                    {hasDeliveredRecords && (
                      <div
                        className="inline-block"
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                      >
                        <CSVLink
                          data={csvDataForDownload}
                          headers={csvHeaders}
                          filename="shipment_details_delivered.csv"
                          className="text-primary font-weight-bold"
                        >
                          <i className="fa fa-download" /> Delivered
                        </CSVLink>
                      </div>
                    )}

                    {/* Pending Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForDownloadPending}
                        headers={csvHeaders}
                        filename="shipment_details_pending.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> Pending
                      </CSVLink>
                    </div>

                    {/* Download COD Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForCOD}
                        headers={csvHeaders}
                        filename="shipment_details_cod.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> COD
                      </CSVLink>
                    </div>

                    {/* Download NON COD Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForNonCod}
                        headers={csvHeaders}
                        filename="shipment_details_non_cod.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> Non COD
                      </CSVLink>
                    </div>

                    {/* Download All Orders Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForDownloadAll}
                        headers={csvHeaders}
                        filename="shipment_details.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> All
                      </CSVLink>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-11">
            {loading && <p>Loading shipment details...</p>}

            {shipmentDetails.length > 0 && (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginBottom: "10px",
                    alignItems: "baseline", // Align children on their baseline (buttons align horizontally)
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      flexShrink: 0,
                      width: "150px",
                    }}
                  >
                    <a
                      onClick={() => handleGeneratePdf(shipmentDetails)}
                      className="btn btn-secondary"
                      style={{
                        fontSize: "17px",
                        cursor: "pointer",
                        background: "#fff",
                        color: "#337ab7",
                        border: "1px solid #337ab7",
                        marginRight: "5%",
                      }}
                    >
                      <i
                        className="fa fa-file-pdf-o"
                        style={{ marginRight: "5px" }}
                      ></i>{" "}
                      Generate PDF
                    </a>
                    <p style={{ margin: "5px 0 0 0" }}>
                      {" "}
                      {pdfload ? "loading..." : ""}
                    </p>
                  </div>
                </div>

                <h4 style={{ textAlign: "left" }}>Track Summary:</h4>
                <div className="row">
                  <div className="col-md-4" style={{ float: "right" }}>
                    <select
                      style={{ float: "right", marginBottom: "3%" }}
                      onChange={handleFilterChange}
                    >
                      <option value="All">All</option>
                      <option value="COD">COD</option>
                      <option value="NON COD">NON COD</option>
                      <option value="DELIVERED">Delivered</option>
                      <option value="PENDING">Pending</option>
                    </select>
                  </div>
                </div>
                <div
                  className="shipdata"
                  style={{
                    background: "#5583af59",
                    maxHeight: "500px", // Adjust the height limit as needed
                    overflowY: "auto", // Enables vertical scrolling
                    // padding: '10px',   // Optional: Add some padding for better visuals
                    border: "1px solid #ccc", // Optional: Add a border for separation
                    // marginBottom:'3%'
                  }}
                >
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>AWB</th>
                        <th>Status</th>
                        <th>Last Transit Date</th>
                        <th>Last Transit Time</th>
                        <th>Courier</th>
                        <th>Shipper</th>
                        <th>Consignee</th>
                        <th>Pickup Location</th>
                        <th>Ambient Count</th>
                        <th>Ambient Temp</th>
                        <th>Chilled Count</th>
                        <th>Chilled Temp</th>
                        <th>Frozen Count</th>
                        <th>Frozen Temp</th>
                        <th>Handover by</th>
                        <th>Received by</th>
                        {/* <th>Payment Type</th>
      <th>COD</th> */}
                        <th>Updated By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredShipmentDetails.map((data, index) => {
                        const [datePart = "", timePart = ""] = (
                          data.modifiedDate || ""
                        ).split(" ");
                        const isDelivered =
                          data.STATUS?.toLowerCase() === "delivered";

                        return (
                          <tr key={index}>
                            <td>{data.jobId}</td>
                            <td>{data.STATUS}</td>
                            <td>{datePart}</td>
                            <td>{timePart}</td>
                            <td>{data.driverName}</td>
                            <td>{data.shipperContactName || "--"}</td>
                            <td>
                              {data.contactName || ""}
                              {data.contactAddress
                                ? ` - ${data.contactAddress}`
                                : ""}
                            </td>
                            <td>{data.pickupLocation || "--"}</td>
                            <td>{data.ambientCount ?? "0"}</td>
                            <td>{data.ambientTemperature || "--"}</td>
                            <td>{data.chilledCount ?? "0"}</td>
                            <td>{data.chilledTemperature || "--"}</td>
                            <td>{data.frozenCount ?? "0"}</td>
                            <td>{data.frozenTemperature || "--"}</td>
                            <td>{data.handoverName || "--"}</td>
                            <td>{data.receiverName || "--"}</td>
                            {/* <td>{data.paymentType || "--"}</td>
          <td>{isDelivered ? (data.codDetails ?? 0) : 0}</td>
          <td>{isDelivered ? (data.cashCollected ?? 0) : 0}</td>*/}
                            <td>
                              {data.updated_by
                                ? data.updated_by
                                : data.driverName}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
